
const cubic = (value: number) => Math.pow(value, 3);
const easeInOutCubic = (value: number) => value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;

export const scrollToTop = (el?: HTMLElement) => {
  if (import.meta.env.SSR) return;
  const target = el || document.documentElement;
  if (!target) {
    throw new Error(`target is not existed: ${target}`);
  }
  const beginTime = Date.now();
  const beginValue = target.scrollTop;
  const rAF = window.requestAnimationFrame;
  const frameFunc = () => {
    const progress = (Date.now() - beginTime) / 500;
    if (progress < 1) {
      target.scrollTop = beginValue * (1 - easeInOutCubic(progress));
      rAF(frameFunc);
    } else {
      target.scrollTop = 0;
    }
  };
  rAF(frameFunc);
};
